export default function Sidebar({
  activePage,
  setActivePage,
  currentUser,
  actionMenuItems = [],
  logout
}) {
  const paymentItems = [
    "Реестр платежей",
    ...actionMenuItems.map((item) => item.label)
  ];
  const adminItems = [
    ...paymentItems,
    "Отчеты",
    "Справочник",
    "Шаблон",
    "Настройки",
    "Пользователи"
  ];
  const financierItems = [
    ...paymentItems,
    "Отчеты"
  ];
  const directorItems = [
    ...paymentItems,
    "Отчеты"
  ];
  const systemAdminItems = [
    "Компании"
  ];
  const items = currentUser?.role === "ADMIN"
    ? adminItems
    : currentUser?.role === "SYSTEM_ADMIN"
      ? systemAdminItems
      : currentUser?.role === "FINANCIER"
        ? financierItems
        : currentUser?.role === "DIRECTOR"
          ? directorItems
          : currentUser?.role === "ACCOUNTANT"
            ? paymentItems
            : paymentItems;

  return (
    <div className="sidebar">
      <h2>FinFlow</h2>

      <div className="user-switcher">
        Текущий пользователь
        <strong>{currentUser?.name}</strong>
        <span>{currentUser?.username}</span>
        <span>{currentUser?.role_label}</span>
      </div>

      {items.map((item) => (
        <div
          key={item}
          className={`sidebar-item ${activePage === item ? "active" : ""}`}
          onClick={() => setActivePage(item)}
        >
          {item}
        </div>
      ))}

      <button className="logout-btn" onClick={logout}>
        Выход
      </button>
    </div>
  );
}
